/**
 * Table Scroll Guide
 * 
 * テーブルが横スクロール可能な場合にガイド画像を表示し、
 * ユーザーがスクロールしたら非表示にする機能
 */

class TableScrollGuide {
  constructor() {
    this.tableWraps = document.querySelectorAll('.table-wrap');
    this.guides = new Map();
    this.scrollHandlers = new Map();
    this.resizeHandler = this.handleResize.bind(this);
    this.init();
  }

  init() {
    this.tableWraps.forEach((tableWrap) => {
      this.setupGuide(tableWrap);
    });
  }

  setupGuide(tableWrap) {
    // 既にガイドが存在するかチェック
    const existingGuide = tableWrap.querySelector('.table-scroll-guide');
    if (existingGuide) {
      existingGuide.remove();
    }

    // 既存のイベントリスナーを削除
    const existingScrollHandler = this.scrollHandlers.get(tableWrap);
    if (existingScrollHandler) {
      tableWrap.removeEventListener('scroll', existingScrollHandler);
    }

    // ガイド要素を作成
    const guide = document.createElement('div');
    guide.className = 'table-scroll-guide';
    guide.innerHTML = '<img src="/assets/img/common/table-encourage.png" alt="横スクロールしてください">';
    
    // テーブルラップに追加
    tableWrap.appendChild(guide);
    this.guides.set(tableWrap, guide);

    // スクロール状態をチェック
    this.checkScrollability(tableWrap);

    // スクロールイベントリスナーを追加
    const scrollHandler = () => {
      this.hideGuide(tableWrap);
    };
    this.scrollHandlers.set(tableWrap, scrollHandler);
    tableWrap.addEventListener('scroll', scrollHandler);

    // 初回のリサイズイベントリスナー追加（1度だけ）
    if (!this.resizeListenerAdded) {
      window.addEventListener('resize', this.resizeHandler);
      this.resizeListenerAdded = true;
    }
  }

  handleResize() {
    this.tableWraps.forEach((tableWrap) => {
      this.checkScrollability(tableWrap);
    });
  }

  checkScrollability(tableWrap) {
    const guide = this.guides.get(tableWrap);
    if (!guide) return;

    // スクロール可能かどうかをチェック
    const isScrollable = tableWrap.scrollWidth > tableWrap.clientWidth;
    const hasNotScrolled = tableWrap.scrollLeft === 0;

    console.log('Table scroll check:', {
      scrollWidth: tableWrap.scrollWidth,
      clientWidth: tableWrap.clientWidth,
      isScrollable,
      hasNotScrolled,
      scrollLeft: tableWrap.scrollLeft
    });

    if (isScrollable && hasNotScrolled) {
      this.showGuide(tableWrap);
    } else {
      this.hideGuide(tableWrap);
    }
  }

  showGuide(tableWrap) {
    const guide = this.guides.get(tableWrap);
    if (guide) {
      console.log('Showing guide for table');
      guide.classList.add('show');
    }
  }

  hideGuide(tableWrap) {
    const guide = this.guides.get(tableWrap);
    if (guide) {
      console.log('Hiding guide for table');
      guide.classList.remove('show');
    }
  }
}

export default TableScrollGuide;